import { Phone, Mail, MessageCircle, MapPin, Navigation } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSiteContent } from "@/context/ContentContext";

export function ContactCards() {
  const { contact } = useSiteContent();
  const cards = [
    { icon: Phone, label: "Call Us", value: contact.phoneDisplay, href: `tel:${contact.phone}`, testid: "contact-card-call" },
    { icon: MessageCircle, label: "WhatsApp", value: "Message our team", href: `https://wa.me/${contact.whatsapp}`, testid: "contact-card-whatsapp" },
    { icon: Mail, label: "Email", value: contact.email, href: `mailto:${contact.email}`, testid: "contact-card-email" },
    { icon: Navigation, label: "Directions", value: "Open location", href: "#map", testid: "contact-card-directions" },
  ];
  return (
    <div className="grid gap-px bg-[#E3E8EF] border border-[#E3E8EF] sm:grid-cols-2 lg:grid-cols-4" data-testid="contact-cards">
      {cards.map((c, i) => (
        <Reveal key={c.label} delay={i * 0.06}>
          <a href={c.href} target={c.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={c.testid}
            className="group flex h-full flex-col gap-3 bg-white p-7 transition-colors duration-300 hover:bg-ink">
            <c.icon className="w-7 h-7 text-amber-hover" strokeWidth={1.5} />
            <span className="font-display uppercase text-lg tracking-wide text-ink group-hover:text-white transition-colors">{c.label}</span>
            <span className="text-sm text-muted group-hover:text-white/70 transition-colors break-words">{c.value}</span>
          </a>
        </Reveal>
      ))}
    </div>
  );
}

export function MapPlaceholder() {
  const { contact } = useSiteContent();
  return (
    <div id="map" className="relative flex min-h-[320px] flex-col items-center justify-center overflow-hidden border border-[#E3E8EF] bg-graphite text-center text-white" data-testid="map-placeholder">
      <div className="tech-grid-dark absolute inset-0" />
      <MapPin className="relative w-12 h-12 text-amber" strokeWidth={1.3} />
      <p className="relative mt-4 max-w-md px-6 font-display uppercase text-xl tracking-wide">{contact.mapNote}</p>
      <p className="relative mt-2 px-6 text-sm text-white/50">Address: {contact.address}</p>
    </div>
  );
}
